const initContactForm = () => {
    document.querySelectorAll('.ks-contact-form .wpcf7-submit').forEach((submitElement) => {
        if (submitElement.tagName.toLowerCase() !== 'input') {
            return;
        }

        const submitButton = document.createElement('button');
        submitButton.type = 'submit';
        submitButton.className = submitElement.className;
        submitButton.innerHTML = `<span>${submitElement.value}</span><span class="ks-contact-form-submit-plus">+</span>`;

        if (submitElement.name) {
            submitButton.name = submitElement.name;
        }

        if (submitElement.id) {
            submitButton.id = submitElement.id;
        }

        if (submitElement.disabled) {
            submitButton.disabled = true;
        }

        submitElement.replaceWith(submitButton);
    });
};

export default initContactForm;
